/**
 * App reducers
 * Please write a description
 *
 * @author Carlos Silva <csilva@ubiwhere.com>
 *
 * @format
 */

import { createSlice } from '@reduxjs/toolkit';
import config from 'config';
const { ROLES } = config;

interface AppToolsStateI {
  roles: {
    GUEST: string;
  };
}

const initialState: AppToolsStateI = {
  roles: ROLES,
};

export default createSlice({
  name: 'AppTools',
  initialState,
  reducers: {},
});
